module.exports = __webpack_public_path__ + "static/img/img_soldoc_function1.d58cf6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_mobile/img_soldoc_function1.png
// module id = DsaQ
// module chunks = 0